import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `res://` paths of the PackedScenes whose instances enclose the node being
 * rendered, outermost first: `SceneScope.instancedScenePaths` for the React walk.
 * `InstancedNode` reads it to stop cyclic instancing and extends it for the
 * sub-scene it renders.
 */
import { createContext, useContext } from 'react';
const NO_SCENE_PATHS = [];
const InstancedScenePathsContext = createContext(NO_SCENE_PATHS);
InstancedScenePathsContext.displayName = 'InstancedScenePathsContext';
export function InstancedScenePathsProvider({ paths, children }) {
    return _jsx(InstancedScenePathsContext.Provider, { value: paths, children: children });
}
/** The enclosing scenes' paths, or an empty list outside every instance. */
export function useInstancedScenePaths() {
    return useContext(InstancedScenePathsContext);
}
//# sourceMappingURL=InstancedScenePathsContext.js.map